<script>
	export let title = "";
	export let description = "";
	export let backgroundImage = null;
</script>

<section class="relative bg-[#0a0a0f] text-white py-32 overflow-hidden">
	<!-- Background Elements -->
	<div
		class="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/20 blur-[120px] rounded-full pointer-events-none animate-pulse-glow"
	></div>
	<div
		class="absolute bottom-0 left-0 w-[500px] h-[500px] bg-neon-cyan/5 blur-[120px] rounded-full pointer-events-none"
	></div>

	<!-- Grid -->
	<div
		class="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:40px_40px] [mask-image:radial-gradient(ellipse_at_center,black,transparent_70%)]"
	></div>

	<div class="container mx-auto px-6 max-w-5xl relative z-10 text-center">
		{#if description}
			<p
				class="text-sm font-bold uppercase tracking-widest text-primary mb-4 animate-slide-up"
				style="animation-delay: 0.1s;"
			>
				{description}
			</p>
		{/if}
		<h1
			class="text-5xl md:text-7xl font-bold mb-6 animate-slide-up"
			style="animation-delay: 0.2s;"
		>
			{title}
		</h1>
	</div>
</section>
